class LbFindMyFit extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll('.lb-fmf__gap');
    this.titleEl = this.querySelector('[data-fmf-title]');
    this.noteEl = this.querySelector('[data-fmf-note]');
    this.ctaEl = this.querySelector('[data-fmf-cta]');
    this.targetUrl = this.getAttribute('data-target-url') || '/collections/all';

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button));
    });
  }

  select(button) {
    this.buttons.forEach((b) => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');

    const mm = parseInt(button.dataset.mm, 10);
    const copy = this.copyFor(mm);

    if (this.titleEl) this.titleEl.textContent = `${mm}mm covers and clips`;
    if (this.noteEl) this.noteEl.textContent = copy;
    if (this.ctaEl) {
      this.ctaEl.textContent = `Shop ${mm}mm accessories`;
      const separator = this.targetUrl.includes('?') ? '&' : '?';
      this.ctaEl.setAttribute('href', `${this.targetUrl}${separator}gap=${mm}`);
    }
  }

  copyFor(mm) {
    if (mm <= 11) {
      return 'A narrower gap. Our push-fit and interlocking accessories flex to hold a snug fit at this end of the range.';
    }
    if (mm <= 18) {
      return 'The most common range. Most of our accessories in this range cover 10–20mm gaps with the stated fitting method.';
    }
    return 'A wider gap. Check the stated fit range on each product page, and get in touch if you are not sure which size to order.';
  }
}

customElements.define('lb-find-my-fit', LbFindMyFit);
